import { render, staticRenderFns } from "./UpcaseString.vue?vue&type=template&id=bd3cd38e&"
import script from "./UpcaseString.vue?vue&type=script&lang=js&"
export * from "./UpcaseString.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports